























import { Component, Vue } from 'vue-property-decorator';
import { Action, Mutation } from 'vuex-class';
import { authService } from '../../services/AuthService';

@Component({})
export default class AppSessionTimeout extends Vue {
  public sessionExpiring = false;
  private activityCallback!: (ev: Event) => void;
  private idleHandle!: number;
  @Action('logout')
  private logout!: () => void;
  @Mutation('sessionSuspended/storeLastUrl')
  private storeLastUrl!: (lastUrl: string) => void;

  mounted() {
    this.activityCallback = this.onActivity.bind(this);
    window.addEventListener('mousemove', this.activityCallback, true);
    window.addEventListener('click', this.activityCallback, true);
    window.addEventListener('keypress', this.activityCallback, true);
    window.addEventListener('focus', this.activityCallback, true);
    window.addEventListener('scroll', this.activityCallback, true);
    this.resetIdleTimeout();
  }

  beforeDestroy() {
    window.removeEventListener('mousemove', this.activityCallback);
    window.removeEventListener('click', this.activityCallback);
    window.removeEventListener('keypress', this.activityCallback);
    window.removeEventListener('focus', this.activityCallback);
    window.removeEventListener('scroll', this.activityCallback);
  }

  onActivity() {
    if (!this.sessionExpiring) {
      this.resetIdleTimeout();
    }
  }

  public doorgaan() {
    this.resetIdleTimeout();
  }

  private resetIdleTimeout() {
    this.sessionExpiring = false;
    clearTimeout(this.idleHandle);
    this.idleHandle = setTimeout(() => {
      this.sessionExpiring = true;
      this.idleHandle = setTimeout(() => {
        this.logout();
        this.storeLastUrl(this.$route.fullPath);
        authService.logout();
      }, 2 * 60 * 1000); // 2 minutes expiring dialog
    }, 8 * 60 * 1000); // 8 minutes inactivity
  }
}
